import { render, staticRenderFns } from "./contract-header.component.vue?vue&type=template&id=4dc1650a"
import script from "./contract-header.component.vue?vue&type=script&lang=ts"
export * from "./contract-header.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports